module.exports = __webpack_public_path__ + "static/media/hz_tu1.8c39784c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hz_tu1.jpg
// module id = 1587
// module chunks = 10